<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>

      <div class="container-login"  >
          <div class="wrap-login">
            <div class="row">
                    <div class="col-sm-12 col-md-6 col-xl-6 col-xl-6"  style="color:#000;font-size:30px;font-family: open-sans">
                            <img src="assets/images/logo.png" style="    width: 60%;">

                    </div>

                  <div class="form-group"  >

                      <form [formGroup]="registrationform"  (ngSubmit)=" doSignup()">
                          <div class="wrap-inputlogin form-group">

                          <input type="text" name="name" placeholder="Enter your Name" id="name" [(ngModel)]="registrationform.name" class="inputlogin form-control" formControlName="name" >
                          <span class="symbol-inputlogin">
                            <i class="fa fa-user" aria-hidden="true"></i>
                          </span>
                          </div>
                          <div  *ngIf="( registrationform.get('name').hasError('required') ) && registrationform.get('name').touched">

                                  <div class="error" style="color:red;font-size:20px" *ngIf="registrationform.get('name').hasError('required') && registrationform.get('name').touched">
                                  Name is required
                                </div>
                          </div>

                          <div class="wrap-inputlogin form-group">

                          <input type="email" placeholder="Enter email Id" name="email" id="email" [(ngModel)]="registrationform.email" class="inputlogin form-control" formControlName="email" required>
                          <span class="symbol-inputlogin">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                          </span>
                          </div>

                          <div *ngIf="( registrationform.get('email').hasError('required') || registrationform.get('email').hasError('pattern') ) && registrationform.get('email').touched">

                                      <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('email').hasError('required') && registrationform.get('email').touched">
                                                Email is required
                                      </div>
                                      <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('email').hasError('pattern') && registrationform.get('email').touched">
                                                  Enter Correct Email Id
                                      </div>
                          </div>



                          <div class="wrap-inputlogin form-group">

                          <input type="mobile" placeholder="Enter Mobile No" name="mobile" id="mobile" [(ngModel)]="registrationform.mobile" class="inputlogin form-control" formControlName="mobile" required>
                          <span class="symbol-inputlogin">
                            <i class="fa fa-phone" aria-hidden="true"></i>
                          </span>
                          </div>

                          <div  *ngIf="( registrationform.get('mobile').hasError('required')  || registrationform.get('mobile').hasError('minLength') ) && registrationform.get('mobile').touched">

                            <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('mobile').hasError('required') && registrationform.get('mobile').touched">
                              Mobile Number is required
                            </div>
                            <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('mobile').hasError('minLength') && registrationform.get('mobile').touched">
                              This is not a valid Mobile Number
                            </div>

                          </div>


                          <div class="wrap-inputlogin form-group">
                          <input type="password" placeholder="Enter Password" name="password" id="password"  [(ngModel)]="registrationform.password" class="inputlogin form-control" formControlName="password" required>
                          <span class="symbol-inputlogin">
                            <i class="fa fa-lock" aria-hidden="true"></i>
                          </span>

                          </div>

                          <div *ngIf="( registrationform.get('password').hasError('required') ) && registrationform.get('password').touched">

                                                <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('password').hasError('required') && registrationform.get('password').touched">
                                                Password is required
                                                </div>
                                                <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('password').hasError('minLength') && registrationform.get('password').touched">
                                                  enter Six Digit password
                                                  </div>
                                              </div>


                          <div class="wrap-inputlogin form-group">
                                  <input type="password" placeholder="Confirm Entered Password" name="cnfmPass" id="cnfmpass" [(ngModel)]="registrationform.cnfmpass" class="inputlogin form-control" formControlName="cnfmPass" >
                                  <span class="symbol-inputlogin">
                                    <i class="fa fa-lock" aria-hidden="true"></i>
                                  </span>

                              </div>


                                      <div *ngIf="( registrationform.get('cnfmPass').hasError('equalTo') || registrationform.get('cnfmPass').hasError('required') ) && registrationform.get('cnfmPass').touched">

                                            <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('cnfmPass').hasError('required') && registrationform.get('cnfmPass').touched">

                                            Confirm password is required
                                            </div>
                                            <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('cnfmPass').hasError('equalTo') && registrationform.get('cnfmPass').touched">
                                            Password Mismatch
                                            </div>
                                      </div>

                                      <div class="row">
                                          <div class="col-12">
                                                  <button  class="btn login" type="submit" [disabled]="!registrationform.valid">Sign up</button>
                                          </div>

                                          <div id="loginbtn" style="margin-top:30px; margin-left: 15px; height:50px;">
                                                <span routerLink="/signin"> >> Sign In

                                              </span>
                                                  </div>
                                            </div>
              </form>
                      </div>

        </div>
      </div>
      </div>

            <div style="background-color: #cb983f;text-align:center;" >
                          <div class="footer-copyright">
                                  <div class="container-fluid" >
                                 <h2 style="font-family: open-sans;  color: #fff"> © 2018 PETCART</h2>

                                  </div>
                              </div>

                  </div>
